var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('b-img',{staticClass:"passion-lead-us",attrs:{"src":_vm.passionLeadUsImg}})],1),_c('FlambuAnalytics'),_c('FlambuStory'),_c('TryFlumbuMobile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }